import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { AppSupportedLanguages } from 'src/app/core/languages-support/i18n-config.service';
import { I18nModule } from 'src/app/core/languages-support/i18n.module';
import { AutoCompleteFormFieldModule } from 'src/app/libs/ui/components/auto-complete-form-field/auto-complete-form-field.module';

import { FindTripFormModule } from './components/find-trip-form/find-trip-form.module';
import { HomePageRoutingModule } from './home-page-routing.module';
import { HomePageComponent } from './home-page.component';
import { DateRangeModule } from "../../../../../libs/ui/components/date-range/date-range.module";
import { HomeBannerComponent } from './components/home-banner/home-banner.component';
import { FlightSearchModule } from './components/flight-search/flight-search.module';
import { CardModule } from 'src/app/libs/ui/components/card/card.module';
import { TopHotelCarouselModule } from './components/top-hotel-carousel/top-hotel-carousel.module';
import { EventCarouselComponent } from 'src/app/libs/ui/components/event-carousel/event-carousel.component';
import { EventCarouselModule } from 'src/app/libs/ui/components/event-carousel/event-carousel.module';
import { TestimonialModule } from 'src/app/libs/ui/components/testimonial/testimonial.module';
import { OfferServicesModule } from './components/offer-services/offer-services.module';
import { HowWorksModule } from './components/how-works/how-works.module';
import { SearchFormPanelModule } from 'src/app/libs/ui/components/search-form-panel/search-form-panel.module';

@NgModule({
    declarations: [
        HomePageComponent,
        HomeBannerComponent
    ],
    imports: [
        CommonModule,
        HomePageRoutingModule,
        MatCardModule,
        MatInputModule,
        MatDatepickerModule,
        MatGridListModule,
        AutoCompleteFormFieldModule,
        FindTripFormModule,
        FlightSearchModule,
        I18nModule.forRoot(AppSupportedLanguages),
        DateRangeModule,
        TopHotelCarouselModule,
        EventCarouselModule,
        TestimonialModule,
        OfferServicesModule,
        HowWorksModule,
        SearchFormPanelModule
    ]
})
export class HomePageModule { }
